/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../../../../../../contexts";
import { useState, useCallback, useRef, useContext, useEffect } from "react";
import DependentBenefitGridDetails from "../dependentBenefitDetails/dependentBenefitGridDetails/DependentBenefitGridDetails";
import DependentVEBBenefitDetailsGrid from "./dependentVEBBenefitGridDetails/DependentVEBBenefitDetailsGrid";
import { VEBEnrollment } from "../../../../../../../../../@types/enrollment.types";
import { GetDependentBenefitsQuery } from "../../../../../../../../../utils/api/enrollment/enrollment";
import { DependentBenefitDetailsProps } from "../../../../../../../../../@types/components/memberDetailsProps.types";
import { api } from "../../../../../../../../../utils/api";

const ITEM_HEIGHT = 48;

// eslint-disable-next-line react/prop-types
const DependentVEBBenefitDetails = ({ dependent }: DependentBenefitDetailsProps): JSX.Element => {
	const [currentBenefits, setCurrentBenefits] = useState<VEBEnrollment[]>([]);
	const [futureBenefits, setFutureBenefits] = useState<VEBEnrollment[]>([]);
	const { setDashboardHeader } = useContext(UIContext);

	const getVEBBenefits = useCallback(async () => {
		const getVEBDependentBenefitsQuery: GetDependentBenefitsQuery = {
			insured_SSN: dependent.employee_SSN,
			member_SSN: dependent.SSN,
			group_number: dependent.group_number.toString()
		};
		const _VEBDependentBenefits: VEBEnrollment[] = await api.enrollments.getVEBDependentBenefits(
			getVEBDependentBenefitsQuery
		);
		const _currentBenefits: VEBEnrollment[] = [];
		const _futureBenefits: VEBEnrollment[] = [];
		_VEBDependentBenefits.forEach((VEBDependentBenefit: VEBEnrollment) => {
			const { effective_date } = VEBDependentBenefit;
			if (new Date() > new Date(effective_date as unknown as string)) {
				_currentBenefits.push(VEBDependentBenefit);
			} else {
				_futureBenefits.push(VEBDependentBenefit);
			}
		});
		setCurrentBenefits(Object.assign([], _currentBenefits));
		setFutureBenefits(Object.assign([], _futureBenefits));
	}, [dependent.SSN, dependent.employee_SSN, dependent.group_number]);

	useEffect(() => {
		getVEBBenefits();
	}, [getVEBBenefits]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.dependent_veb_benefit_details);
	}, [setDashboardHeader]);

	return (
		<div className="dependent-VEB-benefits-grid-container">
			<div className="pf-title">Current VEB Benefit</div>
			<DependentVEBBenefitDetailsGrid benefits={currentBenefits} benefitType="ACTIVE" />
			<div className="pf-title">Future VEB Benefit</div>
			<DependentVEBBenefitDetailsGrid benefits={futureBenefits} benefitType="FUTURE" />
		</div>
	);
};

export default DependentVEBBenefitDetails;
